module.exports = fox._r("fonts/mc-icons-liveshow.woff", __webpack_public_path__ + "_/_/_/_/common/liveshow/fonts/1pK02sy.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/fonts/mc-icons-liveshow.woff
// module id = 188
// module chunks = 4